import { assertNever } from '@framework/engine';
import { t } from '@framework/i18n';
import { Tag, TagProps, Tooltip } from 'antd';
import { darken } from 'polished';
import * as React from 'react';
import styled from 'styled-components';
const StyledTag = styled(Tag)`
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  .anticon {
    font-size: 0.9em;
    margin-right: 0.2em;
  }
  &&& {
    /* font-weight: 600; */
    color: ${props => darken(0.1, props.theme.moduleDelegateColor)};
    background-color: rgba(255, 255, 255, 0.86);
  }
`;

/**
 * Ritorna le impostazioni per il tag
 *
 */
function getTagOptions(role?: IActorRoleTagProps['role']): TagProps {
  if (!role)
    return {
      color: 'default',
      bordered: true,
      children: t('tag-options.utente', 'Utente'),
    };
  switch (role) {
    case 'attorney':
      return {
        color: 'purple',
        bordered: false,
        children: t('tag-options.procuratore', 'Procuratore'),
      };
    case 'manager':
      return {
        color: 'purple',
        bordered: false,
        children: t('tag-options.gestore', 'Gestore'),
      };
    case 'applicant':
      return {
        color: 'purple',
        bordered: false,
        children: t('tag-options.titolare', 'Titolare'),
      };
    case 'delegate':
      return {
        color: 'purple',
        bordered: false,
        children: t('tag-options.delegato', 'Delegato'),
      };
  }
  assertNever(role);
}

export interface IActorRoleTagProps {
  role?: 'attorney' | 'manager' | 'applicant' | 'delegate' | null;
}

/**
 * Tag di un utente delegato
 */
export function ActorRoleTag(props: IActorRoleTagProps) {
  const { role } = props;

  if (!role) return null;

  const tagOptions = getTagOptions(role);

  return (
    <Tooltip
      title={t(
        'actor-role-tag.tipo-utente-delegato',
        `Sei {{tagOption}} della Richiesta.`,
        { tagOption: tagOptions.children as string },
      )}
    >
      <StyledTag {...tagOptions} />
    </Tooltip>
  );
}
